import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["navigationOverallStats", "signOutLink", "languageSelectorGroup"];

  connect() {
    this.scrollToTop();
    this.initBootstrapTooltip();
  }

  scrollToTop() {
    document.getElementById('toTop').addEventListener("click", function(){
      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    });
  }

  gtagEventTrackLink(event) {
    const element = event.currentTarget
    const eventCategory = element.dataset.eventCategory
    const source = element.dataset.source
    const destination = element.dataset.destination
    // GA3 Universal
    // gtag('event', 'click', {
    //   'event_category': eventCategory,
    //   'event_label': source,
    //   'source': source,
    //   'destination': destination
    // });

    // GA4
    gtag('event', eventCategory, {
      'source': source,
      'destination': destination
    });
  }

  initBootstrapTooltip() {
    $(function() {
      const resetTooltip = () => {
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="popover"]').not(".btn-promotion").popover(
          {
            trigger: "manual",
            html: true,
            animation:false
          }
        ).on("mouseenter", function () {
          var _this = this;
          $(this).popover("show");
            $(".popover").on("mouseleave", function () {
              setTimeout(function () {
                $(_this).popover('hide');
              }, 100);
          });
        }).on("mouseleave", function () {
          var _this = this;
          setTimeout(function () {
            if (!$(".popover:hover").length) {
              $(_this).popover("hide");
            }
          }, 300);
        });
      };

      window.addEventListener("coingecko-reset-tooltip", resetTooltip);
      setTimeout(resetTooltip, 300);
    });
  }

  async navigateToUrl(e) {
    let url = e.currentTarget.dataset.url
    let method = e.currentTarget.dataset.method;

    if (!url) return;
    if (!method || method.trim().toUpperCase() === "GET") {
      window.location = url;
    } else {
      // Create a fake <a href> tag, but don't inject it into DOM.
      let fakeLink = document.createElement("a");
      fakeLink.href = url;
      fakeLink.dataset.method = method;

      // temp fix for https://3.basecamp.com/4235100/buckets/20228664/todos/6944446413#__recording_7100487587
      await this.updateCsrfToken();

      // Pass the fake <a href> tag to the Rails.handleMethod function directly.
      Rails.handleMethod.call(fakeLink, null);
    }
  }

  showLanguageSelectorModal() {
    // Highlight active language.
    this.languageSelectorGroupTarget.querySelector(`div.language-selector-item[data-locale='${I18n.locale}']`).classList.add("active");

    window.dispatchEvent(new CustomEvent("show-language-selector", { detail: true }));
  }

  async updateCsrfToken() {
    const response = await fetch("/accounts/csrf_meta.json");
    const data = await response.json();
    const token = data.token;

    const metaTag = document.querySelector('meta[name="csrf-token"]');

    if (metaTag) {
      metaTag.setAttribute('content', token);
    }

    const inputTags = document.querySelectorAll('input[name="authenticity_token"]')

    if (inputTags) {
      inputTags.forEach((tag) => {
        tag.setAttribute('value', token);
      });
    }
  }
}
